"use client";

import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function UnitsHero() {
  const [currentTime, setCurrentTime] = useState("06:00");
  useEffect(() => {
    const times = ["06:00", "09:00", "12:00", "15:00", "18:00", "21:00"];
    let index = 0;
    const interval = setInterval(() => {
      index = (index + 1) % times.length;
      setCurrentTime(times[index]);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <section data-section-id="2838" id="units-hero" className="relative min-h-screen w-full overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay loop muted playsInline className="h-full w-full object-cover" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pancasila_youth_hq.png">
          <source src="/img/pancasila_youth_hq.mp4" type="video/mp4" />
        </video>
        {}
        <div className="absolute inset-0" style={{
        background: "linear-gradient(to top right, hsla(25, 31%, 10%, 0.85) 0%, hsla(25, 31%, 10%, 0.5) 40%, hsla(25, 31%, 10%, 0.2) 75%, hsla(25, 31%, 10%, 0.1) 100%)"
      }} />
      </div>

      {}
      <div className="pointer-events-none absolute inset-x-4 inset-y-4 z-10 border md:inset-x-8 md:inset-y-8" style={{
      borderColor: "hsla(25, 83%, 55%, 0.2)"
    }} aria-hidden="true" />

      {}
      <div className="absolute left-8 top-8 z-20 md:left-12 md:top-12">
        <span className="font-mono text-xs tracking-widest uppercase" style={{
        color: "hsla(25, 83%, 55%, 0.8)"
      }}>
          {currentTime} <span className="mx-1 opacity-50">→</span> 21:00
        </span>
      </div>

      {}
      <div className="absolute right-8 top-8 z-20 md:right-12 md:top-12">
        <span className="font-mono text-xs tracking-[0.3em] uppercase" style={{
        color: "hsla(25, 83%, 55%, 0.8)"
      }}>
          ABADI
        </span>
      </div>

      {}
      <div className="relative z-20 flex min-h-screen flex-col justify-end px-8 pb-24 pt-32 md:justify-start md:px-16 md:pt-[60vh] md:pb-16 lg:px-24">
        <div className="max-w-4xl">
          <h1 className="font-default font-bold leading-[0.95] tracking-tight text-foreground" style={{
          fontSize: "clamp(3.5rem, 10vw, 10rem)"
        }}>
            Suara{" "}
            <em className="italic font-normal" style={{
            color: "hsl(25, 83%, 55%)"
          }}>
              Perjuangan
            </em>
            ,
            <br />
            Pancasila.
          </h1>

          <p className="mt-8 max-w-xl font-default text-lg md:text-xl" style={{
          color: "hsla(0, 0%, 98%, 0.75)"
        }}>
            Menyajikan berita terkini dan klarifikasi tajam demi keutuhan bangsa.
          </p>

          {}
          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center">
            <Button asChild size="lg" className="h-14 bg-primary px-8 font-mono text-xs uppercase tracking-[0.2em] text-primary-foreground hover:bg-primary/90 rounded-md w-full sm:w-auto shadow-md">
              <Link to="/SendNewsPage">
                Kirim Laporan Berita
              </Link>
            </Button>

            <Button asChild variant="ghost" size="lg" className="h-14 px-8 font-mono text-xs uppercase tracking-[0.2em] text-foreground border border-primary/30 hover:bg-primary/10 hover:text-foreground rounded-md w-full sm:w-auto">
              <Link to="/LivePage">
                <Play className="h-3 w-3" strokeWidth={1.5} />
                Pantau Live Update
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-12 right-8 z-20 hidden md:flex md:right-12 lg:right-16">
        <div className="flex flex-col items-center gap-4">
          <span className="font-mono text-xs tracking-[0.3em] uppercase [writing-mode:vertical-rl] rotate-180" style={{
          color: "hsla(25, 83%, 55%, 0.8)"
        }}>
            Scroll — JELAJAH
          </span>
          <div className="relative h-20 w-px overflow-hidden" style={{
          backgroundColor: "hsla(25, 83%, 55%, 0.2)"
        }}>
            <div className="absolute top-0 left-0 w-full animate-scroll-line" style={{
            height: "40%",
            background: "linear-gradient(to bottom, transparent, hsl(25, 83%, 55%), transparent)"
          }} />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scroll-line {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(250%); }
        }
        .animate-scroll-line {
          animation: scroll-line 2s ease-in-out infinite;
        }
      `}</style>
    </section>;
}